






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Loading extends Vue {
    @Prop(String) private text!: string
    private showSpinner = false

    private mounted() {
        setTimeout(() => {
            this.showSpinner = true
        }, 500)
    }
}
